import { findPersonaById, type PersonaId } from "@/mocks/personas";

const TOKEN_PREFIX = "mock-token.";

export const MOCK_TOKEN_TTL_SECONDS = 60 * 60 * 24;

export const createMockToken = (personaId: PersonaId) => {
  return `${TOKEN_PREFIX}${personaId}`;
};

export const getPersonaIdFromRequest = (request: Request) => {
  const [scheme, token] = (request.headers.get("Authorization") ?? "").split(" ");

  if (scheme !== "Bearer" || !token?.startsWith(TOKEN_PREFIX)) {
    return null;
  }

  return findPersonaById(token.slice(TOKEN_PREFIX.length))?.id ?? null;
};
